/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HTTPPolicySetModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from 'ng/shared/shared.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { httpPolicySetCollectionProvider } from './ajs-upgraded-providers';
import { HTTPPolicySetListComponent } from './components';

/**
 * @description
 *
 *      Angular Module for HTTP policy set related components.
 *
 * @author Rohit Gaikwad, Abhinesh Gour
 */
@NgModule({
    declarations: [
        HTTPPolicySetListComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        DataGridModule,
    ],
    providers: [
        httpPolicySetCollectionProvider,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HTTPPolicySetModule {}
